<script lang="ts" setup>
const { t } = useTranslation()
const userStore = useUserStore()
const { isEpaperSubscribeSuccessPage, isEpaperRegisterSuccessPage, isEpaperSubscribed } = useEpaper()

const userEmail = ref<string>('')
const userId = ref<string>('')

const alertTitle = computed(() => {
  if (isEpaperSubscribeSuccessPage.value) {
    return t('epaper.successPage.subscribe.heading')
  } else if (isEpaperRegisterSuccessPage.value && isEpaperSubscribed.value) {
    return t('epaper.successPage.epaperRegister.heading')
  } else {
    return t('epaper.successPage.register.heading')
  }
})

const alertText = computed(() => {
  if (isEpaperSubscribeSuccessPage.value) {
    return t('epaper.successPage.subscribe.alertText')
  } else if (isEpaperRegisterSuccessPage.value && isEpaperSubscribed.value) {
    return t('epaper.successPage.epaperRegister.alertText', { email: userEmail.value })
  } else {
    return t('epaper.successPage.register.alertText', { email: userEmail.value })
  }
})

const setUserEmail = (value: string) => {
  set(userEmail, value)
}

const setUserId = (value: string) => {
  set(userId, value)
}

onBeforeMount(async () => {
  await userStore.fetchUser()
  if (!userStore.user)
    return
  setUserEmail(userStore.user!.email)
  setUserId(userStore.user.id.toString())
})
</script>

<template>
  <div
    v-if="userStore.user"
    m-auto
    flex="~ col"
    class="items-center justify-center lt-sm:w-full"
    w="540px"
  >
    <IaThemeIcon
      icon="i-fad:check"
      size="xl"
      variant="filled"
      class="text-success-500 bg-success-50"
    />
    <IaHeading
      class="mt-4"
      :level="5"
      color="gray-800"
      font-700
    >
      {{ alertTitle }}
    </IaHeading>
    <IaAlert
      class="mt-4"
      type="success"
    >
      {{ alertText }}
    </IaAlert>
    <div
      flex="~ col gap-6 lg:row"
      class="items-center m-auto justify-center lt-sm:gap-4"
      mt-6
      w-full
    >
      <IaNuxtLink
        v-if="(isEpaperRegisterSuccessPage && isEpaperSubscribed) || isEpaperSubscribeSuccessPage"
        to="/epaper/magazine"
      >
        <IaButton
          variant="primary"
          normal-case
          class="lt-sm:w-full"
        >
          {{ t('epaper.successPage.subscribe.button.toMagazine') }}
        </IaButton>
      </IaNuxtLink>
      <IaNuxtLink
        v-else
        to="/"
      >
        <IaButton
          variant="primary"
          normal-case
          class="lt-sm:w-full"
        >
          {{ t('epaper.successPage.register.button') }}
        </IaButton>
      </IaNuxtLink>
      <IaNuxtLink
        v-if="(isEpaperRegisterSuccessPage && isEpaperSubscribed) || isEpaperSubscribeSuccessPage"
        :to="`/kundenkonto/${userId}`"
      >
        <IaButton
          variant="outline"
          class="lt-sm:w-full normal-case"
        >
          {{ t('epaper.successPage.subscribe.button.toMyAccount') }}
        </IaButton>
      </IaNuxtLink>
    </div>
  </div>
</template>
